import React, { Component } from "react";
import { Button, Row, Col, Container } from "mdbreact";
import axios from "axios";
import domain from "./domain";
import { Link } from "react-router-dom";
import DownloadModal from './DownloadModal'
import cas from "./casClient/CasService";
import colors from './colors'
import { Accordion, Icon } from 'semantic-ui-react'
import ETTable from './datadownload/ETTable'
import GLOFTable from './datadownload/GLOFTable'
import SnowTable from './datadownload/SnowTable'
import VICTable from './datadownload/VICTable'
import DroughtTable from './datadownload/DroughtTable'
import IrrTable from './datadownload/IrrTable'
import { Segment } from 'semantic-ui-react'
import MapView from './datadownload/MapView'

import { MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact'
import moment from 'moment'
import _ from 'lodash'

import swal from "sweetalert";
import { faSortNumericUp, faSortNumericUpAlt } from "@fortawesome/free-solid-svg-icons";
// import { addDays, differenceInDays, differenceInBusinessDays } from 'date-fns';
function differenceInDays(date2, date1) {
  // To calculate the time difference of two dates
  var Difference_In_Time = date2.getTime() - date1.getTime();

  // To calculate the no. of days between two dates
  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  return Difference_In_Days
}
function dateFormatter(cell) {
  let s = new Date(cell);

  return `${("0" + s.getDate()).slice(-2)}/${("0" + (s.getMonth() + 1)).slice(
    -2
  )}/${s.getFullYear()}`;
}
const getDatesBetweenDates = (startDate, endDate) => {
  let dates = []
  //to avoid modifying the original date
  const theDate = new Date(startDate)
  while (theDate < endDate) {
    dates = [...dates, new Date(theDate)]
    theDate.setDate(theDate.getDate() + 1)
  }
  return dates
}

export default class NHPDataDownload extends Component {
  constructor(props) {
    super(props)
    this.state = {
      submitdisable: true,
      cropmapyears: null,
      cropmapseasons: null,
      cropyear: '#',
      cropseason: '#',
      userrequests: null,
      enableCheckStatus: window.sessionStorage.getItem("glofrequeststatus") ? window.sessionStorage.getItem("glofrequeststatus") : false,
      //GLOF states
      rivernames: null,
      riverselected: "#",
      basinnames: null,
      basinselected: null,
      subbasinnames: null,
      subbasinselected: null,
      activeIndex: window.sessionStorage.getItem("clickitem") ? window.sessionStorage.getItem("clickitem") : null,
      statenames: null,
      stateselected: '#',
      districtselected: '#',
      districtnames: null,

      loginmodal: false,
      themeselected: null,
      year: '#',
      season: '#',
      monthly: false,
      //  products:null,
      modalpopup: false,
      date: null,
      vicdownloadinfo: null,
      vicselectedproduct: '#',
      vicproducts: null,
      vicstart_date: null,
      vicend_date: null,
      products: null,
      etdownloadinfo: null,
      etselectedproduct: '#',
      etproducts: null,
      etstart_date: null,
      etend_date: null,

      etmonthly_yrs:null,
      etmonthly_data: null,
      etfortnightly_data: null,
      etmn_yrMonths:null,
      etmn_selectedYear: null,
      etmn_selectedMonth:null,
      etmn_selectedFile:null,
      etfn_selectedFile:null,
      etfn_yrMonths:null,
      etfortnightly_yrs:null,
      etfn_selectedYear: null,
      etfn_selectedMonth:null,
      etfn_selectedFortnight:null,

      sriproducts: null,
      snowdownloadinfo: null,
      snowselectedproduct: '#',
      snowproducts: null,
      snowstart_date: null,
      snowend_date: null,
      date2: null,
      date1: null,
      d1: null,
      d2: null,
      hddate: null,
      hdavailableDates: null,
      hdselectedproduct: '#',
      hdstart_date: null,
      hdend_date: null,
      hddownloadinfo: null,
      hdproducts: null,
      activeIndex1: null,
      download_enable: false,
      etdates:[],
      snowdates:[],
      snowavailableDates:[],
      vicdates:[],
      selectionRange:
        {

          startDate: null,
          endDate: null,
          key: 'selection'

        },
    }
  }

  // mn_YearChange = (e) => {
  //   console.log("event for drop",e)
  //   if (e.target.value !== '#') {
  //     this.mn_getMonths(e.target.value)
  //     this.setState({
  //       etmn_selectedYear: e.target.value
  //     })
  //   }
  // }

  // mn_MonthChange = (e) => {
  //   if (e.target.value !== '#') {
  //     // this.mn_getMonths(e.target.value)
  //     this.setState({
  //       etmn_selectedMonth: e.target.value
  //     })

  //     let find1 = this.state.monthly_dates.filter((item) => (item.year === this.state.mn_selectedYear && item.month === e.target.value));

  //     this.props.setSelectedMNLayer(find1[0].layerdate)
  //   }
  // }

  mn_getMonths = (e) => {
    // let mn_yrMonths = [];
    // console.log("getmonfths",e)
    let find1 = this.state.etmonthly_data.filter((item) => (item.year === e))
    
    // console.log('MOnts', this.state.monthly_dates)
    // console.log('Find', find1)

    this.setState({
      etmn_yrMonths: find1
    })
  }
  fn_getMonths = (e) => {
    // let mn_yrMonths = [];
    let months = new Set();
//etfortnightly_yrs
// console.log('YeAer ',e)
    let find1 = this.state.etfortnightly_data.filter((item) => (item.year === e))
    // console.log(this.state.etfortnightly_data)
    find1.map((item) => {
      months.add(item.month);
    });
    
    // console.log('MOnts', this.state.fortnightly_dates)
    // console.log('Find', find1)
    // console.log('Month', months)

    this.setState({
      etfn_yrMonths: Array.from(months)
    })
  }


  fn_MonthChange = (e) => {
    // this.props.setSelectedFNLayer("", "")
    
    if (e !== '#') {
      // this.setState({
      //   fn_selectedMonth: e.target.value
      // })
      this.fn_getFN(e)
    }else
    {
      // this.state.setfn_selectedYear(null)
      // this.state.setfn_selectedMonth(null)
      // this.state.setfn_selectedFortnight(null)
    }
  }
  
  fn_getFN = (e) => {
    // console.log('E', e)
    // console.log('MOnts', this.state.fortnightly_dates)
    let fortnight = new Set();
    // console.log('selected year',this.state.etfn_selectedYear)
    // console.log('selected month',e)
    let find1 = this.state.etfortnightly_data.filter((item) => (item.year === this.state.etfn_selectedYear && item.month === e))

    find1.map((item) => {
      fortnight.add(item.fortnight);
    });
    // console.log('Find', find1)

    this.setState({
      fn_MnFortnight: Array.from(fortnight)
    })
  }

  setmn_selectedYear = (e) => {
    // console.log(e);
    this.setState({
      etmn_selectedYear: e
    })
  }


  setmn_selectedMonth = (e) => {
    console.log(e);
    let filtered_date = [];
    let data=null;
    if(e!='#' && e!=null)
    {
    filtered_date = this.state.etmonthly_data.filter((et)=>{
      return (et.year === this.state.etmn_selectedYear && et.month === e)
    });
    data='MN_'+filtered_date[0].layerdate
  }
    console.log('asdfdas', filtered_date);
    // this.availableDates_monthly.filter(e)=
    this.setState({
      etmn_selectedMonth: e,
      etmn_selectedFile : data ,
    })
  }


  setfn_selectedYear = (e) => {
    console.log('fortnightly', this.state.etfortnightly_data);
    this.setState({
      etfn_selectedYear: e
    })
  }

  setfn_selectedMonth = (e) => {
    console.log(e);
    this.setState({
      etfn_selectedMonth: e
    })
  }


  setfn_selectedFortnight = (e) => {
    console.log(e);
    let filtered_date = [];
    let data=null;
    if(e!='#' && e!=null)
    {
    filtered_date = this.state.etfortnightly_data.filter((et)=>{
      return (et.year === this.state.etfn_selectedYear && et.month === this.state.etfn_selectedMonth &&
    et.fortnight===e )
   
    });
    data=e+'_'+filtered_date[0].layerdate
  }
    console.log('fortnightly', this.state.etfortnightly_data);
    this.setState({
      etfn_selectedFortnight: e,
      etfn_selectedFile:data
    })
  }

  async componentDidMount() {
    let result = await axios.get(`${domain.DBServer}/get-download-data-info`)
    if (result) {
      console.log("get-download-data-info",result.data)
      if (result.data) {
        this.setState({
          products: result.data
        })
      }
    }
    this.getCropYears();
    // let result1=await axios.get(`https://bhuvan-staging1.nrsc.gov.in/clogout?service=https%3A%2F%2Fbhuvan-staging1.nrsc.gov.in%2Fnhp_cas%2Fnhp-data-download`)
    // console.log(result1)

  }
  getCropYears = async () => {
    let result = await axios.get(`${domain.DBServer}/fetch-crop-years`)
    if (result) {
      let year
      if (result.data) {
        year = Math.max.apply(Math, result.data.map(function (o) { return o.year; }))

      }
      let result1 = await axios.get(`${domain.DBServer}/fetch-crop-year-season/${year}`)
      if (result1) {
        // console.log(year)
        this.setState({
          cropmapyears: result.data,
          cropyear: year,
          // cropseason:'kharif',
          cropmapseasons: result1.data
        })
      }

    }
  }

  getBasinNames = (river) => {
    axios.get(`${domain.DBServer}/fetch-gl-download-basinnames/${river}`).then((result) => {
      if (result) {
        this.setState({
          basinnames: result.data,
        });

      }
    })
  }


  handleRiverSelected = (e) => {
    let river = e.target.value;

    if (river !== "#") {
      this.getBasinNames(river)
      this.setState({
        riverselected: river,
        basinselected: "#",
        subbasinselected: "#",
        // basins:null,
      })
    }
    else {
      this.setState({
        riverselected: e.target.value,
        basinselected: "#",
        subbasinselected: "#",
        subbasinnames: null,
        basinnames: null,
      })
    }
  }
  getGLOFSubBasins = (basin) => {
    axios
      .get(
        `${domain.DBServer}/fetch-gl-download-subbasinnames/${this.state.riverselected}/${basin}`
      )
      .then((result) => {
        if (result) {
          this.setState({
            subbasinnames: result.data,
          });
        }
      });
  }
  handleBasinChange = (e) => {
    let basin = e.target.value;
    if (basin !== "#") {
      this.getGLOFSubBasins(basin)
      this.setState({
        basinselected: basin,
      });
    }

    else {
      this.setState({
        basinselected: '#',
        riverselected: this.state.riverselected,
        subbasinselected: '#',
        subbasinnames: null,
      })

    }
  }
  handleSubbasinChange = (e) => {
    if (e.target.value !== '#') {
      this.setState({
        subbasinselected: e.target.value,
        submitdisable: false
      })
    }
  }
  getRiverSystemNames = () => {
    axios.get(`${domain.DBServer}/fetch-gl-download-rivernames`).then((result) => {
      if (result) {
        console.log(result);
        this.setState({
          rivernames: result.data,
        });
      }
    });
  }
  getDistrictNames = (state) => {
    axios.get(`${domain.DBServer}/fetch-glof-districts/${state}`).then((result) => {
      if (result) {
        console.log(result);
        this.setState({
          districtnames: result.data,
        });
      }
    });
  }
  handleDistrictChange = (e) => {
    if (e.target.value !== '#') {
      this.setState({
        districtselected: e.target.value,
        submitdisable: false
      })
    }
  }
  handleSubmitDisable = () => {
    this.setState({
      submitdisable: !this.state.submitdisable
    })
  }

  handleStateChange = (e) => {
    if (e.target.value !== '#') {
      this.getDistrictNames(e.target.value)
      this.setState({
        stateselected: e.target.value,
        districtselected: '#',
        submitdisable: false
      })
    }
  }
  getStateNames = () => {
    axios.get(`${domain.DBServer}/fetch-glof-states`).then((result) => {
      if (result) {
        console.log(result);
        this.setState({
          statenames: result.data,
        });
      }
    });
  }
 
  checkStatusGL = async () => {
    this.setState({
      glofstatus: false
    })
    const url = `${domain.DBServer}/get-glof-request-status`
    const data = {

      username: window.sessionStorage.getItem("loginUser"),
      // username:'syam_rs'
      // username:
    }
    let result = await axios.request({
      method: 'post',
      url: url,
      data: data,
    })
    window.sessionStorage.setItem("glofrequeststatus", true)
    if (result) {
      if (result.data.length > 0) {
        console.log(result.data)
        this.setState({
          enableCheckStatus: true,
          userrequests: result.data
        })
      }
    }
  }

  handleClick_GL = (e, titleProps) => {
    this.setState({

      glofstatus: false,
      userrequests: null,
      enableCheckStatus: false,
    })
    const { index } = titleProps
    const { activeIndex1 } = this.state
    const newIndex = activeIndex1 === index ? -1 : index
    if (newIndex === 0) {
      this.setState({

        // statenames: null,
        stateselected: '#',
        districtselected: '#',
        districtnames: null,
      })
    }
    else if (newIndex === 1) {
      this.setState({
        //rivernames: null,
        riverselected: "#",
        basinnames: null,
        basinselected: '#',
        subbasinnames: null,
        subbasinselected: '#',
      })
    }
    this.setState({ activeIndex1: newIndex })
  }

  handleThemeChange = (e) => {
    if (e.target.value !== '#') {
      this.setState({
        themeselected: e.target.value
      })
      if (e.target.value === 'ET') {
        this.setState({
          etproducts: ['Energy Balance']
        })
      }
    }
  }

  state = { activeIndex: 0 }
  toggleLoginModal = () => {
    this.setState({
      loginmodal: !this.state.loginmodal
    })
  }
  handleLogin = async () => {
    try {
      cas.redirect();
      let result = await cas.getLogin()

    } catch (err) {
      if (err.error !== "login_required") console.log("error: " + err);
    }
  }
  handleClick = (e, titleProps) => {
   if (window.sessionStorage.getItem("loginUser") !== null) {
//  if(1){
      this.setState({
        cropyear: '#',
        cropseason: '#',
        loginmodal: false,
        submitdisable: true,
        glofstatus: false,
        userrequests: null,
        enableCheckStatus: false,
        rivernames: null,
        riverselected: "#",
        basinnames: null,
        basinselected: null,
        subbasinnames: null,
        subbasinselected: null,
        activeIndex1: null,
        statenames: null,
        stateselected: '#',
        districtselected: '#',
        districtnames: null,
        themeselected: null,
        productselected: null,
        etdownloadinfo: null,
        modalpopup: false,
        vicdownloadinfo: null,
        vicselectedproduct: '#',
        vicproducts: null,
        vicstart_date: null,
        vicend_date: null,
        snowdownloadinfo: null,
        snowselectedproduct: '#',
        snowproducts: null,
        snowstart_date: null,
        snowend_date: null,
        monthly: false,
        etselectedproduct: '#',
        hdselectedproduct: '#',
        hdstart_date: null,
        hdend_date: null,
        etproducts: null,
        sriproducts: null,
        etstart_date: null,
        etend_date: null,
        date2: null,
        date1: null,
        d1: null,
        d2: null,
        snowavailableDates: null,
        hdavailableDates: null,
        hddate: null,
        snowdate: null,
        snowstartdate: null,
        snowenddate: null,
        year: '#',
        season: '#',
        hddownloadinfo: null,
        hdproducts: null,
        download_enable: false,
        selectionRange:
          {

            startDate: null,
            endDate: null,
            key: 'selection'

          },
      })
      const { index } = titleProps
      const { activeIndex } = this.state
      const newIndex = activeIndex === index ? -1 : index
      if (newIndex === 0) {
        if (this.state.products) {
          let etproduct = this.state.products.filter((e) => {

            console.log(e.theme,"e.themeEt",this.state.products)
            return (e.theme === 'ET' || e.theme ==='ET-Fortnightly' || e.theme ==='ET-Monthly'|| e.theme==='ET-750'||e.theme==='ET-Fortnightly-750'||e.theme ==='ET-Monthly-750')
          }
          )
          if (etproduct) {
            let products = etproduct.map((e) => { return (e.product) })
            this.setState({
              etdownloadinfo: etproduct,
              etproducts: products
            })
          }
        }
      }
      else if (newIndex === 1) {
        this.getRiverSystemNames()
        this.getStateNames()
      }
      else if (newIndex === 2) {
        if (this.state.products) {
          let snowproduct = this.state.products.filter((e) => {
            return (e.theme === 'SNOW')
          }
          )
                    if (snowproduct) {
            let products = snowproduct.map((e) => { return (e.product) })
            this.setState({
              snowdownloadinfo: snowproduct,
              snowproducts: products
            })
          }
        }
      }
      else if (newIndex === 3) {
        console.log(this.state.products)
        if (this.state.products) {
          let vicproduct = this.state.products.filter((e) => {
            return (e.theme === 'VIC')
          }
          )
          if (vicproduct) {
            let products = vicproduct.map((e) => { return (e.product) })
            this.setState({
              vicdownloadinfo: vicproduct,
              vicproducts: products
            })
          }
        }
      }
      else if (newIndex === 5) {
        if (this.state.products) {
          let droughtproduct = this.state.products.filter((e) => {
            return (e.theme === 'Drought')
          })
          if (droughtproduct) {
            let products = droughtproduct.map((e) => { return (e.product) })
            this.setState({
              hddownloadinfo: droughtproduct,
              hdproducts: products
            })
          }
        }
      }

      window.sessionStorage.setItem("clickitem", newIndex);
      this.setState({ activeIndex: newIndex })
   }



    else {
      this.setState({
      loginmodal: true
     })
   }
  }
  getAvailableDates_vic = () => {
    axios
      .request({
        method: "post",
        url: `${domain.DBServer}/get-avail-dates-vic`,
        data: {},
      })
      .then((result) => {
        // let result = await axios({method: 'get', url: `${domain.nodeServer}/get-avail-dates`})
        if (result) {
          if (result.data) {
            console.log(result.data);
            const availableDates = result.data.map((item) => {
              let regex = /\d{4}\d{2}\d{2}/;
              // console.log(item.file_name.match(regex))
              let date = regex.exec(item.filename)[0];
              // availableDates.push(moment(date))
              return moment(date);
            });
            //    console.log(ad)

            // let maxdate = moment.max(availableDates).format("DD-MM-YYYY")
            let maxdate = moment.max(availableDates);
            let mindate = moment.min(availableDates);
            console.log(maxdate);
            let sortedDates = _.sortBy(availableDates, (d) => {
              // console.log(d)
              return new moment(d);
            });
            console.log(sortedDates);
            this.setState({
              //  availableDates: sortedDates,

              vicstart_date: new Date(mindate),
              vicend_date: new Date(maxdate),
              vicdates:sortedDates,
              selectionRange:
                {

                  startDate: new Date(mindate),
                  endDate: new Date(maxdate),
                  key: 'selection'

                },
              // slideTracker: sortedDates.length - 1,
              // selectedLayer:selectedLayer,
              //  datesloading: false,
            });
          }
        }
      });
  }

  handleVICProductChange = (e) => {
    this.setState({
      date1: null,
      submitdisable: true,
    })

    if (e.target.value !== '#') {

      let info = this.state.vicdownloadinfo.filter((p) => { return (p.product === e.target.value) })
      this.getAvailableDates_vic()
      this.setState({
        vicselectedproduct: e.target.value,
      })
    }
    else {
      this.setState({
        vicselectedproduct: e.target.value,
        vicstart_date: null,
        vicend_date: null,
        selectionRange:
          {

            startDate: null,
            endDate: null,
            key: 'selection'

          },
      })
    }
  }
  handleYear = (e) => {
    this.setState({

      submitdisable: true,
    })
    let value = e.target.value
    if (value !== '#') {

      axios.get(`${domain.DBServer}/fetch-crop-year-season/${value}`).then((result) => {

        if (result) {
          this.setState({
            cropmapseasons: result.data,
            cropyear: value,
            cropseason: "#",
          })
        }
      })

    }
  }
  handleSeason = (e) => {
    if (e.target.value !== '#') {
      this.setState({
        cropseason: e.target.value,
        submitdisable: false
      })
    }
  }
  handleHDDateChange = (event, { name, value }) => {
    // let selected_date = moment(value, "DD-MM-YYYY").format("YYYYMMDD");
    this.setState({
      [name]: value,
      download_enable: true,
      submitdisable: false

    });
  };
  getAvailableDates_sri = async (selected) => {

    let regex
    if (selected === 'standardized-groundwater-level-index')
      regex = /[A-Za-z]*[0-9]*/gm
    else
      regex = /[0-9]*/gm
    let availableDates = []
    let result = await axios({
      method: "post",
      url: `${domain.DBServer}/get-avail-dates-${selected}`,
      data: {
        // selected: selected
      },
    });

    if (result) {
      if (result.data) {
        availableDates = result.data.map((item) => {
          console.log(item.filename);

          const nameCapitalized =
            item.filename.charAt(0).toUpperCase() + item.filename.slice(1);
          console.log(nameCapitalized);
          let date = nameCapitalized.match(regex)[0];
          console.log(date);
          if (selected === "standardized-groundwater-level-index")
            // availableDates.push(moment(date))
            return moment(date, ["MMMYYYY"]);
          else return moment(date);
        });

        console.log("available", availableDates);
        let maxdate = moment.max(availableDates);
        let mindate = moment.min(availableDates)

        console.log("maxdate", maxdate);
        let sortedDates = _.orderBy(
          availableDates,
          (d) => {
            return new moment(d);
          },
          ["asc"]
        );

        this.setState({
          hdavailableDates: sortedDates,
          hddate: maxdate,
          hdstart_date: new Date(mindate),
          hdend_date: new Date(maxdate),
          // monthly:true
        });
      }
    }
  }
  handleHDSubProduct = (e) => {
    if (e.target.value !== '#') {
      this.getAvailableDates_sri('standardized-runoff-index')
      this.setState({
        hdsub: e.target.value
      })
    }
  }
  handleDroughtProductChange = (e) => {
    this.setState({
      monthly: false,
      hdsub: '#',
      download_enable: false,
      submitdisable: true,
    })
    if (e.target.value !== '#') {

      let info = this.state.hddownloadinfo.filter((p) => { return (p.product === e.target.value) })
      console.log(info)
      this.setState({
        hdselectedproduct: e.target.value,
        // hdstart_date: new Date(info[0].start_date),
        // hdend_date: new Date(info[0].end_date),
      })
      if (e.target.value === 'Standardized Runoff Index') {

        // this.getAvailableDates_sri('standardized-runoff-index')
        this.setState({
          monthly: false,
          sriproducts: ['30 day SRI', '60 day SRI', '90 day SRI', '180 day SRI', '365 day SRI', 'Annual Cumulative']
        })
      }
      else if (e.target.value === 'Standardized Groundwater Index') {
        this.getAvailableDates_sri('standardized-groundwater-level-index')
        this.setState({
          monthly: true
        })
      }
    }
    else {
      this.setState({
        hdselectedproduct: e.target.value,
        hdstart_date: null,
        hdend_date: null,
        monthly: false,
        hdavailableDates: null,
        submitdisable: true,
        hddate: null
      })
    }

  }
  getETDates=async()=>
  {
   
      let result = await axios({
        method: "post",
        url: `${domain.DBServer}/get-avail-dates-et-evapotranspiration`,
        data: {
          // selected: "Evapotranspiration"
        },
      });
      const availableDates = result.data.map((item) => {
        // let regex =/[0-9]*/gm
        var regex = /[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]/gi;
        let date = item.filename.match(regex)[0];
        // console.log(date)
        // availableDates.push(moment(date))
        return moment(date);
      });
      //    console.log(ad)
  
      // let maxdate = moment.max(availableDates).format("DD-MM-YYYY")
      let maxdate = moment.max(availableDates);
      let mindate = moment.min(availableDates);
      console.log(maxdate);
      let sortedDates = _.sortBy(availableDates, (d) => {
        // console.log(d)
        return new moment(d);
      });
      this.setState({
        etmonthly_data: null,
        etmonthly_yrs:null,
        etfortnightly_data:null,
        etfortnightly_yrs:null,
        etdates:sortedDates,
        // etmn_selectedMonth:null,
        // etmn_selectedYear:null,
        // etmn_yrMonths:null,
        etstart_date: new Date(mindate),
        etend_date: new Date(maxdate),
        selectionRange:
          {

            startDate: new Date(mindate),
            endDate: new Date(maxdate),
            key: 'selection'
          },
      })
}
getETDates750=async()=>
{
 
    let result = await axios({
      method: "post",
      url: `${domain.DBServer}/get-avail-dates-et-evapotranspiration750`,
      data: {
        // selected: "Evapotranspiration"
      },
    });
    const availableDates = result.data.map((item) => {
      // let regex =/[0-9]*/gm
      var regex = /[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]/gi;
      let date = item.filename.match(regex)[0];
      // console.log(date)
      // availableDates.push(moment(date))
      return moment(date);
    });
    //    console.log(ad)

    // let maxdate = moment.max(availableDates).format("DD-MM-YYYY")
    let maxdate = moment.max(availableDates);
    let mindate = moment.min(availableDates);
    console.log(maxdate);
    let sortedDates = _.sortBy(availableDates, (d) => {
      // console.log(d)
      return new moment(d);
    });
    this.setState({
      etmonthly_data: null,
      etmonthly_yrs:null,
      etfortnightly_data:null,
      etfortnightly_yrs:null,
      etdates:sortedDates,

      // etmn_selectedMonth:null,
      // etmn_selectedYear:null,
      // etmn_yrMonths:null,
      etstart_date: new Date(mindate),
      etend_date: new Date(maxdate),
      selectionRange:
        {

          startDate: new Date(mindate),
          endDate: new Date(maxdate),
          key: 'selection'
        },
    })
}
getETMothly750=async()=>
{
    let result = await axios({
      method: "post",
      url: `${domain.DBServer}/get-avail-dates-et-Evapotranspiration-Monthly750`,
      data: {
        // selected: "Evapotranspiration"
      },
    });
    // let month_yrs=[];
    const month_yrs = new Set()
    const availableDates_monthly = result.data.map((item) => {
      // console.log(item);
      var regex = /[0-9][0-9][0-9][0-9][0-9][0-9]/gi;
      let date = item.filename.match(regex)[0];
      month_yrs.add(moment(date).format('YYYY'));
      // console.log('Date: '+ date +' Year: '+  + ' Month: ' + moment(date).format('MMMM'));
      return {
        "layerdate" : date,
        "year" : moment(date).format('YYYY'),
        "month" : moment(date).format('MMMM')
      };
    });
console.log("hurry",availableDates_monthly);
    this.setState({
      etmn_selectedMonth:null,
      etmn_selectedYear:null,
      etmn_yrMonths:null,
      etmonthly_data : availableDates_monthly,
      etmonthly_yrs:Array.from(month_yrs)
    });
}

getETMothly=async()=>
{
    let result = await axios({
      method: "post",
      url: `${domain.DBServer}/get-avail-dates-et-Evapotranspiration-Monthly`,
      data: {
        // selected: "Evapotranspiration"
      },
    });
    // let month_yrs=[];
    const month_yrs = new Set()
    const availableDates_monthly = result.data.map((item) => {
      // console.log(item);
      var regex = /[0-9][0-9][0-9][0-9][0-9][0-9]/gi;
      let date = item.filename.match(regex)[0];
      month_yrs.add(moment(date).format('YYYY'));
      // console.log('Date: '+ date +' Year: '+  + ' Month: ' + moment(date).format('MMMM'));
      return {
        "layerdate" : date,
        "year" : moment(date).format('YYYY'),
        "month" : moment(date).format('MMMM')
      };
    });
console.log("hurry",availableDates_monthly);
    this.setState({
      etmn_selectedMonth:null,
      etmn_selectedYear:null,
      etmn_yrMonths:null,
      etmonthly_data : availableDates_monthly,
      etmonthly_yrs:Array.from(month_yrs)
    });
}
getETFortnightly750=async()=>
{
 
    let result = await axios({
      method: "post",
      url: `${domain.DBServer}/get-avail-dates-et-Evapotranspiration-Fortnightly750`,
      data: {
        // selected: "Evapotranspiration"
      },
    });
    // let fortnight_yrs=[];
    const fortnight_yrs = new Set()
    const availableDates_fortnightly = result.data.map((item) => {
      // console.log(item);
      var regex1 = /FN[0-9]/gi;
      let fortn = item.filename.match(regex1)[0];
      var regex = /[0-9][0-9][0-9][0-9][0-9][0-9]/gi;
      let date = item.filename.match(regex)[0];
      fortnight_yrs.add(moment(date).format('YYYY'));
      // console.log('Fornt: '+ fortn +' Date: '+ date +' Year: '+ moment(date).format('YYYY') + ' Month: ' + moment(date).format('MMMM'));
      return {
        "layerdate" : date,
        "year" : moment(date).format('YYYY'),
        "month" : moment(date).format('MMMM'),
        "fortnight" : fortn,
      };
    });

    this.setState({
      etfortnightly_data:null,
      etfortnightly_yrs:null,
      etfortnightly_data : availableDates_fortnightly,
      etfortnightly_yrs:Array.from(fortnight_yrs)
    });

    // console.log("adsadasds",availableDates_fortnightly);

}


getETFortnightly=async()=>
{
 
    let result = await axios({
      method: "post",
      url: `${domain.DBServer}/get-avail-dates-et-Evapotranspiration-Fortnightly`,
      data: {
        // selected: "Evapotranspiration"
      },
    });
    // let fortnight_yrs=[];
    const fortnight_yrs = new Set()
    const availableDates_fortnightly = result.data.map((item) => {
      // console.log(item);
      var regex1 = /FN[0-9]/gi;
      let fortn = item.filename.match(regex1)[0];
      var regex = /[0-9][0-9][0-9][0-9][0-9][0-9]/gi;
      let date = item.filename.match(regex)[0];
      fortnight_yrs.add(moment(date).format('YYYY'));
      // console.log('Fornt: '+ fortn +' Date: '+ date +' Year: '+ moment(date).format('YYYY') + ' Month: ' + moment(date).format('MMMM'));
      return {
        "layerdate" : date,
        "year" : moment(date).format('YYYY'),
        "month" : moment(date).format('MMMM'),
        "fortnight" : fortn,
      };
    });

    this.setState({
      etfortnightly_data:null,
      etfortnightly_yrs:null,
      etfortnightly_data : availableDates_fortnightly,
      etfortnightly_yrs:Array.from(fortnight_yrs)
    });

    // console.log("adsadasds",availableDates_fortnightly);

}


  handleETProductChange = (e) => {
    if (e.target.value !== '#') {
      if(e.target.value==='Actual Evapotranspiration')
      this.getETDates()

      if(e.target.value==='Actual Evapotranspiration fortnightly')
      this.getETFortnightly()

      if(e.target.value==='Actual Evapotranspiration monthly')
      this.getETMothly()
    
      if(e.target.value==='Actual Evapotranspiration 750')
      this.getETDates750()
                  
      if(e.target.value==='Actual Evapotranspiration fortnightly 750')
      this.getETFortnightly750()

      if(e.target.value==='Actual Evapotranspiration monthly 750')
      this.getETMothly750()
 
 
      // let info = this.state.etdownloadinfo.filter((p) => { return (p.product === e.target.value) })
       console.log("inffffo", e.target.value)
      this.setState({
        etselectedproduct: e.target.value,
        // etstart_date: new Date(info[0].start_date),
        // etend_date: new Date(info[0].end_date),
        // selectionRange:
        //   {

        //     startDate: new Date(info[0].start_date),
        //     endDate: new Date(info[0].end_date),
        //     key: 'selection'

        //   },
      })
    }
    else {
      this.setState({
        etmonthly_data: null,
        etmonthly_yrs:null,
        etfortnightly_data:null,
        etfortnightly_yrs:null,
        etselectedproduct: e.target.value,
        etstart_date: null,
        etend_date: null,
        selectionRange:
          {

            startDate: null,
            endDate: null,
            key: 'selection'

          },
      })
    }
  }

  getAvailableDates_snow = (wms_url) => {
    let availableDates = [];

    axios.get(`${domain.DBServer}/fetch-${wms_url}`).then((result) => {
      if (result) {
        if (result.data) {
          result.data.map((r) => {
            //  console.log(r.date);
            availableDates.push(moment(r.date));
            return true;
          });
          //  console.log(availableDates);

          let sortedDates = availableDates.sort(
            (a, b) => a.valueOf() - b.valueOf()
          );
          let maxdate = moment.max(sortedDates).format("DD-MM-YYYY");
          let mindate = moment.min(sortedDates).format("DD-MM-YYYY");

          // console.log(sortedDates > start)

          // let dates = sortedDates.filter(a => a > start && a < end);
          // let dates=sortedDates.map((d)=>{return(d>start && d<end)})
          // console.log(dates)\
          console.log(maxdate)
          this.setState({
            snowavailableDates: sortedDates,
            snowdate: maxdate,
            snowstart_date: mindate,
            snowend_date: maxdate,
            //snowdates:sortedDates,

          });
        }
      }
    });
  };


  getAvailableDates_snow_area = (wms_url) => {
    let availableDates = [];
    //  console.log(start)
    axios.get(`${domain.DBServer}/fetch-${wms_url}`).then((result) => {
      if (result) {
        if (result.data) {
          result.data.map((r) => {
            //  console.log(r.date);
            availableDates.push(moment(r.date));
            return true;
          });
          //  console.log(availableDates);

          let sortedDates = availableDates.sort(
            (a, b) => a.valueOf() - b.valueOf()
          );
          let maxdate = moment.max(sortedDates)
          let mindate = moment.min(sortedDates)

          // console.log(sortedDates > start)

          // let dates = sortedDates.filter(a => a > start && a < end);
          // let dates=sortedDates.map((d)=>{return(d>start && d<end)})
          // console.log(dates)\
          console.log(maxdate)
          this.setState({
          //  snowavailableDates: sortedDates,
            //   snowdate: maxdate,
            snowstart_date: new Date(mindate),
            snowend_date: new Date(maxdate),
            snowdates:sortedDates,

            selectionRange:
              {

                startDate: new Date(mindate),
                endDate: new Date(maxdate),
                key: 'selection'

              },
          });
        }
      }
    });
  };

  handleSnowProductChange = (e) => {
    let name = e.target.value
    this.setState({
      download_enable: false,
      snowavailableDates: null,
      snowstart_date: null,
      snowend_date: null,
      selectionRange:
        {

          startDate: null,
          endDate: null,
          key: 'selection'

        },
      // snowdate:null
    })
    if (name !== '#') {

      if (name === 'Daily Snow Cover Area') {
        //let info = this.state.snowdownloadinfo.filter((p) => { return (p.product === name) })
        this.getAvailableDates_snow_area('daily-snow-cover')
        this.setState({
          snowselectedproduct: name,
          // snowstart_date: new Date(info[0].start_date),
          // snowend_date: new Date(info[0].end_date),
          // selectionRange:
          //   {

          //     startDate: new Date(info[0].start_date),
          //     endDate: new Date(info[0].end_date),
          //     key: 'selection'

          //   },
        })
      }

      else if (name === 'Snow Cover Fraction') {
        this.setState({
          snowselectedproduct: name,
          // snowstart_date: new Date(info[0].start_date),
          // snowend_date: new Date(info[0].end_date),


        })
        this.getAvailableDates_snow('snow-cover-fraction')
      }

      // let info = this.state.snowdownloadinfo.filter((p) => { return (p.product === name) })
      // let snowstart_date = info[0].start_date
      // let snowend_date = info[0].end_date



      else if (name === 'Estimated spatial snowmelt rate') {
        this.setState({
          snowselectedproduct: name,
           //snowstart_date: new Date(info[0].start_date),
          // snowend_date: new Date(info[0].end_date),


        })
        this.getAvailableDates_snow('actual')
      }

      else if (name === 'Spatial snowmelt rate forecast (3-days)') {
        this.setState({
          snowselectedproduct: name,

        })
        this.getAvailableDates_snow('forecast')
      }
    }

    else {
      this.setState({
        snowselectedproduct: name,
        snowstart_date: null,
        snowend_date: null,
        snowavailableDates: null,
        snowdate: null,
        snowstart_date: null,
        snowend_date: null,
        selectionRange:
          {

            startDate: null,
            endDate: null,
            key: 'selection'

          },
      })
    }
  }


  handleSelect = (ranges) => {
    this.setState(
      {
        date2: null,
        date1: null,
        d1: null,
        d2: null,
        //    selectionRange:null
      }
    )
  

        //(Constraint TRIAL- 31 MAY 2023)
        let no_of_days;
        if (ranges) {
          no_of_days = differenceInDays(new Date(ranges.selection.endDate), new Date(ranges.selection.startDate));
          console.log(no_of_days);
          var downloaddate2 = new moment(ranges.selection.endDate, "YYYYMMDD").format("YYYYMMDD");
          var downloaddate1 = new moment(ranges.selection.startDate, "YYYYMMDD").format("YYYYMMDD");
          console.log(downloaddate1);

        this.setState({
          selectionRange: ranges.selection,
          date2: new Date(ranges.selection.endDate),
          date1: new Date(ranges.selection.startDate),
          d1: downloaddate1,
          d2: downloaddate2,
          submitdisable: false
        })
    }

  }

  

  handleMonthChange = (e) => {
    if (e.target.value !== '#') {
      this.setState({
        hddate: moment(e.target.value, "MMMM YYYY"),
        download_enable: true,
        submitdisable: false
      })
    }
    else {
      this.setState({
        hddate: null,
        download_enable: false,
        submitdisable: true
      })
    }

  }

  handleSnowDateChange = (event, { name, value }) => {
    // let selected_date = moment(value, "DD-MM-YYYY").format("YYYYMMDD");

    this.setState({
      [name]: value,
      download_enable: true,
      submitdisable: false

    });


  };
  render() {
    console.log(window.sessionStorage)
    const { activeIndex } = this.state

    return (
      <Container>
        <Row style={{ height: "100%", margin: "0px", padding: "0px" }}>
          <Col style={{ padding: "0px", marginTop: "3px", marginBottom: "7px", }}>

            <p className="note note-primary">
              <p></p>
              <p>This module enables download of geospatial hydro products developed by NRSC under National Hydrology Project. Users are expected to
           {/* <a href="https://bhuvan-cas1.nrsc.gov.in/cas/login?service=https%3A%2F%2Fbhuvan-staging1.nrsc.gov.in%2Fnhp_cas%2Fnhp-data-download" target='_blank'> */}
                &nbsp;register&nbsp;
           {/* </a> */}
                with Bhuvan before downloading the products.
         </p>

              <p> Following are the products available for download.  <ul>
                <li>
                  Evapotranspiration
               </li>
                <li>
                  Glacial Lake Database
               </li>
                <li>
                  Spatial Snowmelt Rate
               </li>
                <li>
                  Hydrological Products (Surface Runoff, Soil Moisture)
                 </li>
                <li>
                  Narayanpur Irrigation Command Crop maps</li>
                <li>
                  Hydrological Drought Indices
                   </li>
              </ul>
              </p>
            </p>
          </Col>
        </Row>
        <Row style={{ height: "100%", margin: "0px", padding: "0px" }}>
          <Col style={{ height: "100%", margin: "0px", padding: "0px" }}>
            {
              this.state.loginmodal ? <MDBModal isOpen={this.state.loginmodal} toggle={this.toggleLoginModal} centered>
                <MDBModalHeader
                  className="text-center"
                  titleClass="w-100 font-weight-bold"
                  toggle={this.toggleLoginModal}
                >
                  Message
          </MDBModalHeader>
                <MDBModalBody>Please Login </MDBModalBody>
                <MDBModalFooter className="justify-content-center">
                  <button className="btn btn-primary text-capitalize" onClick={this.handleLogin}>Login</button>
                </MDBModalFooter>
              </MDBModal> : null
            }
            <p className="note note-primary">
              <Accordion >
                <Accordion.Title
                  active={activeIndex === 0}
                  index={0}
                  onClick={this.handleClick}
                  style={{ color: colors.white }}
                >
                  <Icon name='dropdown' />
                  <strong> Evapotranspiration</strong>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 0} >
                  <ETTable
                    etproducts={this.state.etproducts} 
                    etselectedproduct={this.state.etselectedproduct} 
                    handleETProductChange={this.handleETProductChange} 
                    etend_date={this.state.etend_date} 
                    etstart_date={this.state.etstart_date}
                    selectionRange={this.state.selectionRange}

                    etmonthly_data={this.state.etmonthly_data}
                    etmonthly_yrs={this.state.etmonthly_yrs}
                    etmn_selectedMonth={this.state.etmn_selectedMonth}
                    etmn_selectedYear={this.state.etmn_selectedYear}
                    etmn_yrMonths={this.state.etmn_yrMonths}
                    mn_getMonths = {this.mn_getMonths}
                    setmn_selectedYear = {this.setmn_selectedYear}
                    setmn_selectedMonth = {this.setmn_selectedMonth}
                    etmn_selectedFile={this.state.etmn_selectedFile}



                    etfortnightly_data={this.state.etfortnightly_data}
                    etfortnightly_yrs={this.state.etfortnightly_yrs}
                    // setfortnightly_yrs={this.state.setfortnightly_yrs}
                    etfn_selectedMonth={this.state.etfn_selectedMonth}
                    etfn_yrMonths={this.state.etfn_yrMonths}
                    fn_getMonths = {this.fn_getMonths}
                    fn_getFN = {this.fn_getFN}
                    fn_MonthChange= {this.fn_MonthChange}
                    fn_MnFortnight={this.state.fn_MnFortnight}
                    etfn_selectedFile={this.state.etfn_selectedFile}
                    etdates={this.state.etdates}
                    
                    setfn_selectedYear = {this.setfn_selectedYear}
                    etfn_selectedYear = {this.state.etfn_selectedYear}
                    setfn_selectedMonth = {this.setfn_selectedMonth}
                    setfn_selectedFortnight = {this.setfn_selectedFortnight}
                    etfn_selectedFortnight = {this.state.etfn_selectedFortnight}

        // etmn_selectedMonth:null,
        // etmn_selectedYear:null,
        // etmn_yrMonths:null,
                    handleSelect={this.handleSelect}
                    d1={this.state.d1} 
                    d2={this.state.d2} 
                    date1={this.state.date1} 
                    date2={this.state.date2}
                    submitdisable={this.state.submitdisable} 
                    handleSubmitDisable={this.handleSubmitDisable} />
                </Accordion.Content>

                <Accordion.Title
                  active={activeIndex === 1}
                  index={1}
                  onClick={this.handleClick}
                >
                
   {/* GLOF */}             
                  <Icon name='dropdown' />
                  <strong>   Glacial Lake Database</strong>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 1}>
                  <GLOFTable
                    basinnames={this.state.basinnames} basinselected={this.state.basinselected} rivernames={this.state.rivernames} riverselected={this.state.riverselected} subbasinnames={this.state.subbasinnames} subbasinselected={this.state.subbasinselected}
                    statenames={this.state.statenames} districtnames={this.state.districtnames}
                    stateselected={this.state.stateselected} districtselected={this.state.districtselected}
                    handleRiverSelected={this.handleRiverSelected} handleBasinChange={this.handleBasinChange} handleSubbasinChange={this.handleSubbasinChange}
                    handleStateChange={this.handleStateChange} handleDistrictChange={this.handleDistrictChange}
                    handleClick_GL={this.handleClick_GL}
                    activeIndex={this.state.activeIndex1}
                    enableGLOFStatus={this.enableGLOFStatus}
                    checkGLStatus={this.checkStatusGL}
                    requestid={this.state.requestid}
                    userrequests={this.state.userrequests}
                    enableCheckStatus={this.state.enableCheckStatus}
                    submitdisable={this.state.submitdisable} handleSubmitDisable={this.handleSubmitDisable}

                  />
                </Accordion.Content>

                <Accordion.Title
                  active={activeIndex === 2}
                  index={2}
                  onClick={this.handleClick}
                >
                
          {/* SNOWMELT */}           
                  <Icon name='dropdown' />
                  <strong>    Spatial Snowmelt Rate</strong>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 2}>
                  <SnowTable
                    snowproducts={this.state.snowproducts} snowselectedproduct={this.state.snowselectedproduct}
                    handleSnowProductChange={this.handleSnowProductChange} snowend_date={this.state.snowend_date} snowstart_date={this.state.snowstart_date}
                    selectionRange={this.state.selectionRange}
                    handleSelect={this.handleSelect}
                    d1={this.state.d1} d2={this.state.d2} date1={this.state.date1} date2={this.state.date2}
                    handleSnowDateChange={this.handleSnowDateChange}
                    snowavailableDates={this.state.snowavailableDates}
                    snowdate={this.state.snowdate}
                    snowstartdate={this.state.snowstartdate}
                    snowenddate={this.state.snowenddate}
                    download_enable={this.state.download_enable}
                    submitdisable={this.state.submitdisable} handleSubmitDisable={this.handleSubmitDisable}
                    snowdates={this.state.snowdates}
                  />
                </Accordion.Content>
                <Accordion.Title
                  active={activeIndex === 3}
                  index={3}
                  onClick={this.handleClick}
                >
                 
                 
                  <Icon name='dropdown' />
                  <strong>  Hydrological Products (Surface Runoff, Soil Moisture) </strong>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 3}>
                  <VICTable
                    vicproducts={this.state.vicproducts} vicselectedproduct={this.state.vicselectedproduct} handleVICProductChange={this.handleVICProductChange} vicend_date={this.state.vicend_date}
                    vicstart_date={this.state.vicstart_date}
                    selectionRange={this.state.selectionRange}
                    handleSelect={this.handleSelect}
                    vicdates={this.state.vicdates}
                    d1={this.state.d1} d2={this.state.d2} date1={this.state.date1} date2={this.state.date2}
                    submitdisable={this.state.submitdisable} handleSubmitDisable={this.handleSubmitDisable} />
                </Accordion.Content>
                <Accordion.Title
                  active={activeIndex === 4}
                  index={4}
                  onClick={this.handleClick}
                >
                
                
                 <Icon name='dropdown' />
                  <strong>   Narayanpur Irrigation Command Crop maps </strong>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 4}>
                  <IrrTable year={this.state.year} season={this.state.season} handleYear={this.handleYear} handleSeason={this.handleSeason} submitdisable={this.state.submitdisable} handleSubmitDisable={this.handleSubmitDisable}
                    cropmapyears={this.state.cropmapyears} cropmapseasons={this.state.cropmapseasons} cropyear={this.state.cropyear} cropseason={this.state.cropseason} />
                </Accordion.Content>
                <Accordion.Title
                  active={activeIndex === 5}
                  index={5}
                  onClick={this.handleClick}
                >
                 
                 
                  <Icon name='dropdown' />
                  <strong>    Hydrological Drought Indices</strong>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 5}>
                  <DroughtTable
                    droughtproducts={this.state.hdproducts} handleDroughtChange={this.handleDroughtProductChange} hdproductselected={this.state.hdselectedproduct} hdstart_date={this.state.hdstart_date} hdend_date={this.state.hdend_date}
                    hdavailableDates={this.state.hdavailableDates} hddate={this.state.hddate}
                    monthly={this.state.monthly}
                    handleHDDateChange={this.handleHDDateChange}
                    handleMonthChange={this.handleMonthChange}
                    sriproducts={this.state.sriproducts}
                    hdsub={this.state.hdsub}
                    handleHDSubProduct={this.handleHDSubProduct}
                    download_enable={this.state.download_enable}
                    submitdisable={this.state.submitdisable} handleSubmitDisable={this.handleSubmitDisable}
                  />
                </Accordion.Content>

              </Accordion>
            </p>
          </Col>
        </Row>
      </Container>
    );
  }
}
